import { render, staticRenderFns } from "./ModalDeleteSenderPhone.vue?vue&type=template&id=893c0cea&"
import script from "./ModalDeleteSenderPhone.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteSenderPhone.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteSenderPhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports